import "./styles.scss";

import classNames from "classnames";
import moment from "moment/moment";
import React, { useState } from "react";
import Popup from "reactjs-popup";

import { availableSlots } from "@/components/settings/notificationsCenter/tasks/TimeSelect/constants";
import calendarIcon from "@/images/table-image/icon/calendar-black-icon.svg";

type Props = {
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (...args: any[]) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  date?: any;
};

function TimeSelect({ date, disabled, onChange }: Props) {
  // Variables
  const momentDate = moment(date);
  const midnight = moment(date).startOf("day");
  const diff = momentDate.diff(midnight, "minutes");
  const timeSlot = Math.round(diff / 15);

  // State
  const [showPopup, setShowPopup] = useState(false);

  // @ts-expect-error TS(7006) FIXME: Parameter 'position' implicitly has an 'any' type.
  function addSlotByPosition(position) {
    if (!date) {
      return;
    }

    setShowPopup(false);

    onChange(position * 15);
  }

  const selectedSlot = availableSlots.find(
    (slot) => timeSlot === slot.position,
  );

  const renderTrigger = (
    <li
      className={classNames({
        active: showPopup,
        "time-select--disabled": !date,
        "table-cell--disabled": disabled,
      })}
    >
      {selectedSlot && <div className="time-item">{selectedSlot.time}</div>}

      {!selectedSlot && <span>– Select –</span>}
      <img src={calendarIcon} alt="calendar-icon" />
    </li>
  );

  return (
    <Popup
      disabled={disabled}
      position="bottom left"
      trigger={renderTrigger}
      open={showPopup}
      onOpen={() => setShowPopup(true)}
      onClose={() => setShowPopup(false)}
      keepTooltipInside
      nested
    >
      <div className="users-dropdown time-popup-wrap">
        <ul>
          {availableSlots.map((slot) => {
            return (
              <li
                key={slot.position}
                className={classNames("time-element", {
                  active: timeSlot == slot.position,
                  "table-cell--disabled": disabled,
                })}
                onClick={() => addSlotByPosition(slot.position)}
              >
                {slot.time}
              </li>
            );
          })}
        </ul>
      </div>
    </Popup>
  );
}

export default TimeSelect;
